(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["planificador-granel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-agplan]').forEach(function (root) {
      function eur(cents) {
        var n = (cents / 100).toFixed(2).replace('.', ',');
        return n + ' €';
      }
      function baseGrams(title) {
        var m = (title || '').toLowerCase().match(/([\d.,]+)\s*(kg|g)/);
        return m ? parseFloat(m[1].replace(',', '.')) * (m[2] === 'kg' ? 1000 : 1) : 100;
      }
      var selected = {};
      root.querySelectorAll('[data-agplan-card]').forEach(function (card) {
        var ings = [];
        try { ings = JSON.parse(card.querySelector('[data-agplan-ings]').textContent); } catch (e) {}
        card.addEventListener('click', function () {
          if (selected[card.dataset.id]) { delete selected[card.dataset.id]; card.classList.remove('is-on'); }
          else { selected[card.dataset.id] = ings; card.classList.add('is-on'); }
          render();
        });
      });

      var itemsBox = root.querySelector('[data-agplan-items]');
      var emptyEl = root.querySelector('[data-agplan-empty]');
      var countEl = root.querySelector('[data-agplan-count]');
      var totalEl = root.querySelector('[data-agplan-total]');
      var addBtn = root.querySelector('[data-agplan-add]');

      function aggregate() {
        var map = {};
        Object.keys(selected).forEach(function (rid) {
          selected[rid].forEach(function (ing) {
            if (!map[ing.vid]) map[ing.vid] = { name: ing.name, vid: ing.vid, grams: 0, base: baseGrams(ing.title), price: ing.price };
            map[ing.vid].grams += ing.grams;
          });
        });
        return map;
      }

      function render() {
        var map = aggregate();
        var keys = Object.keys(map);
        itemsBox.querySelectorAll('.agplan-sl').forEach(function (n) { n.remove(); });
        var total = 0;
        if (keys.length === 0) { emptyEl.style.display = 'block'; }
        else {
          emptyEl.style.display = 'none';
          keys.forEach(function (k) {
            var it = map[k];
            var units = Math.ceil(it.grams / it.base);
            var grams = units * it.base;
            var price = units * it.price; // precio = unidades del formato base
            total += price;
            var row = document.createElement('div');
            row.className = 'agplan-sl';
            row.innerHTML = '<span class="agplan-sl__dot"></span><div class="agplan-sl__info"><strong>' + it.name + '</strong><span>' + grams + ' g</span></div><span class="agplan-sl__price">' + eur(price) + '</span>';
            itemsBox.appendChild(row);
          });
        }
        countEl.textContent = keys.length + (keys.length === 1 ? ' ingrediente' : ' ingredientes');
        totalEl.textContent = eur(total);
        addBtn.disabled = keys.length === 0;
        addBtn.textContent = keys.length === 0 ? 'Añadir toda la cesta' : 'Añadir cesta · ' + eur(total);
        addBtn._map = map;
      }

      addBtn.addEventListener('click', function () {
        var map = addBtn._map || {};
        var items = Object.keys(map).map(function (k) {
          var it = map[k];
          return { id: it.vid, quantity: Math.ceil(it.grams / it.base) };
        });
        if (!items.length) return;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json(); })
          .then(function () { AG.refreshCount(); AG.showToast('Cesta añadida · ' + items.length + ' ingredientes'); })
          .catch(function () { AG.showToast('No se pudo añadir'); });
      });

      render();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
